function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M70.904 45.533v-25.44l25.44 25.44z",
    className: "icon_svg__grey",
    style: {
      fill: "#f6a097"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.093h39.516v25.24h25.24v62.643H31.588z",
    className: "icon_svg__black",
    style: {
      fill: "#ef5848"
    }
  }));
};
export default SvgIcon;